export const QUESTIONS = [
  {
    key: "pay_type",
    title: "How are you paid?",
    hint: "This decides which proof of income we ask for.",
    options: [
      { value: "employed", label: "Employed", sub: "I get a payslip" },
      { value: "self_employed", label: "Self-employed", sub: "I file a tax return" },
      { value: "both", label: "Both", sub: "A job and self-employed work" },
    ],
  },
  {
    key: "shares_rent",
    title: "Will anyone share the rent with you?",
    hint: "For example a partner or friend paying part of the rent.",
    options: [{ value: "yes", label: "Yes" }, { value: "no", label: "No" }],
  },
  {
    key: "has_guarantor",
    title: "Do you have a guarantor?",
    hint: "Someone who agrees to pay the rent if you can't.",
    options: [{ value: "yes", label: "Yes" }, { value: "no", label: "No" }],
  },
  {
    key: "current_living",
    title: "Where do you live now?",
    hint: "Just so we know what to expect. It doesn't change what we ask for.",
    options: [
      { value: "renting", label: "Renting" },
      { value: "with_family", label: "With family" },
      { value: "own_home", label: "Own home" },
      { value: "other", label: "Other" },
    ],
  },
];
